import MonthlyStatement from 'features/advance/screens/manageAdvanceAccount/advanceStatements/MonthlyStatement/MonthlyStatements';
import React from 'react';

export default function MonthlyStatementPage() {
  return <MonthlyStatement />;
}
